// 基础方法库
import {
  toDate,
  toFloat,
  trim,
  date,
  toRound,
  format,
  toMoney,
  addFloat,
} from './bll';

/** json */
import { parse } from './bll';

/**
 * String 原生参数扩展方法
 * trim  清除空格
 * toJson 转换为Json对象[=parse]
 * toFloat  字符转浮点数字
 * toDate  替代 new Date() 字符串转标准时间 兼容IOS
 */
const initString = function () {
  /** 清除空格 */
  String.prototype.trim =
    String.prototype.trim ||
    function () {
      return trim(this);
    };

  /*** 字符串转换为Json对象 ***/
  String.prototype.toJson = function () {
    return parse(this);
  };

  //字符转金额,与money 对应使用
  String.prototype.toFloat = function () {
    return toFloat(this);
  };

  /**替代 new Date() 字符串转标准时间 兼容IOS*/
  String.prototype.toDate = function () {
    return toDate(this);
  };
};

/**
 * Date 原生参数扩展方法
 *
 * add(interval,number) 日期 增加数字 new Date().add("d",1)
 * interval 年(y)、月(m)、日(d)、小时(h)、分(n)、秒(s)、周(w)、季度(q)
 *
 * format() 时间格式化为字符串
 * new Date().format("yyyy-MM-dd HH:mm:ss:S")
 * 年(y) 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、豪秒(S)、周(W)、周(w)、季度(q)
 */
const initDate = function () {
  /**
  日期 增加数字 new Date().add("d",1)
  @param interval 年(y)、月(m)、日(d)、小时(h)、分(n)、秒(s)、周(w)、季度(q)
  @param number 增加的数量
 */
  Date.prototype.add =
    Date.prototype.add ||
    function (strInterval, Number) {
      return date.add(strInterval, Number, this);
    };

  /**
   * 时间格式化为字符串
   * new Date().format("yyyy-MM-dd HH:mm:ss:S")
   * 年(y) 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、豪秒(S)、周(W)、周(w)、季度(q)
   */
  Date.prototype.format =
    Date.prototype.format ||
    function (arg) {
      return format(arg, this);
    };

  /*
   * 重写时间的toJSON方法，因为在调用JSON.stringify的时候，时间转换就调用的toJSON，这样会导致少8个小时，所以重写它的toJSON方法
   */
  Date.prototype.toJSON = function () {
    return this.format('yyyy-MM-dd hh:mm:ss'); // util.formatDate是自定义的个时间格式化函数
  };
};

/**
 * Number 原生参数扩展方法
 * toRound,toMoney,add[=addFloat]
 */
const initNumber = function () {
  /**
   * 四舍五入法
   * 解决 toFixed 遇到坑。
   * @param {*} num 转换位数
   */
  Number.prototype.toRound =
    Number.prototype.toRound ||
    function (num) {
      return toRound(this, num);
    };

  /**
   * 数字转换为金额(小数位数,符号,千位标识,小数点标识)
   * @param {*} n 小数位数
   * @param {*} symbol 符号"￥"
   */
  Number.prototype.toMoney =
    Number.prototype.toMoney ||
    function (n, symbol = '￥') {
      return toMoney(this, n, symbol);
    };

  /**
   * 处理js浮点数计算精度不准确问题的解决办法
   * @param {*} arg 加减 数字
   */
  Number.prototype.add =
    Number.prototype.add ||
    function (arg) {
      return addFloat(this, arg);
    };
};

export { initString, initDate, initNumber };
